(ns ui.components.radix-ui.dialog.view
  (:require
   [reagent.core :as r]
   ["@radix-ui/react-dialog" :as Dialog]
   [ui.util :as uu]
   [oops.core :as oops]))


(defn adapt
  [cls-name]
  (r/adapt-react-class (oops/oget+ Dialog cls-name)))

(def dialog-root (adapt "Root"))
(def dialog-trigger (adapt "Trigger"))
(def dialog-portal (adapt "Portal"))
(def dialog-overlay (adapt "Overlay"))
(def dialog-content (adapt "Content"))
(def dialog-title (adapt "Title"))
(def dialog-description (adapt "Description"))
(def dialog-close (adapt "Close"))

(defn view
  ([trigger-component body-component]
   [view {} trigger-component body-component])
  ([props trigger-component body-component]
   (let []
     [dialog-root
      [dialog-trigger
       trigger-component]
      [dialog-portal
       [dialog-overlay]
       [dialog-content
        {:class (uu/cm "bg-base-light")}
        body-component
        [dialog-close
         [:span
          {:icon-name "Cross2Icon"}]]]]])))


(defn controlled
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [title
                footer
                content
                size
                color
                no-close-button?]}
        props]
    [dialog-root
     {:open         (and shown? topmost?)
      :onOpenChange (fn [e]
                      (when-not e
                        (close-modal!)))
      :modal        true}
     [dialog-portal
      {:id "controlled-dialog"}
      [dialog-overlay]
      [dialog-content
       (or content "")
       [dialog-close
        [:span
         {:icon-name "Cross2Icon"}]]]]]))
